import { render } from "./header.vue?vue&type=template&id=1779336d&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=1779336d&scoped=true&lang=scss"
import "./header.vue?vue&type=style&index=1&id=1779336d&lang=scss"

import exportComponent from "C:\\Project\\DeepLink2\\DeepLinkWebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1779336d"]])

export default __exports__